var checkout_form = (function ($) {

    var $checkout;

    var _init = function () {
        $checkout = $('.woocommerce-checkout');

        if ($checkout.length > 0) {
            _init_select2s();
        }
    };

    var _init_select2s = function () {
        $('#billing_title').select2();

        var $select2s = $('select');

        if ($select2s.length > 0) {
            $select2s.each(function () {
                let $select2 = $(this);

                $select2.addClass('select2');
                $select2.select2({
                    dropdownParent: $select2.closest('.woocommerce-input-wrapper'),
                    minimumResultsForSearch: 10
                });
            });
        }
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = checkout_form;